function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import initBusinessTelemetry from '@shared/services/telemetry/1DSClient';
import { logger } from '@src/logger';
const telemetryClient = ()=>{
    let telemetryClient = null;
    return ()=>{
        if (!telemetryClient) {
            telemetryClient = initBusinessTelemetry();
        }
        return telemetryClient;
    };
};
const getTelemetryClient = telemetryClient();
export const initBusinessTelemetryClient = getTelemetryClient;
export const useTelemetry = ()=>{
    const pageView = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(overrideValues, customProperties) {
            const telemetryClient = getTelemetryClient();
            telemetryClient.capturePageView(overrideValues, customProperties);
            logger.clientLogger.logger.capturePageView(overrideValues, customProperties);
        });
        return function pageView(overrideValues, customProperties) {
            return _ref.apply(this, arguments);
        };
    }();
    const pageAction = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(element, overrideValues, customProperties, isRightClick) {
            const telemetryClient = getTelemetryClient();
            telemetryClient.capturePageAction(element, overrideValues, customProperties, isRightClick);
            logger.clientLogger.logger.capturePageAction(element, overrideValues, customProperties, isRightClick);
        });
        return function pageAction(element, overrideValues, customProperties, isRightClick) {
            return _ref.apply(this, arguments);
        };
    }();
    const flushTelemetryBuffer = ()=>{
        const telemetryClient = getTelemetryClient();
        telemetryClient.getPostChannel().flush(false);
        logger.flush();
    };
    return [
        {
            pageAction,
            pageView,
            flushTelemetryBuffer
        },
        {
            telemetryClient
        }
    ];
};
